// extracted by mini-css-extract-plugin
module.exports = {"tag":"Tag_tag__kgugm","is-active":"Tag_is-active__SDuuO","tag__name":"Tag_tag__name__XsM7o"};